// extracted by mini-css-extract-plugin
export default {"login":"Login_login__+H1JP","control":"Login_control__SgCK9","invalid":"Login_invalid__+gD2o","validation-message":"Login_validation-message__Heue4","actions":"Login_actions__Cvd+Z"};